module.exports = __webpack_public_path__ + "img/author.39eb66ea.png";